import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

export type BrokerageLayoutProps = {
  children: React.ReactNode;
  className?: string;
  moduleNavigation?: NavItem;
};

export const BrokerageLayout = ({
  children,
  className,
  moduleNavigation,
}: BrokerageLayoutProps) => (
  <ModuleLayout
    noContentPadding={true}
    moduleNavigation={moduleNavigation}
    className={cn('@BrokerageLayout', className)}
  >
    {children}
  </ModuleLayout>
);
